import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { icons } from '../../../assets';
import { Tooltip } from 'antd';

const baseNamesEstructure = {
    LP01_EPP_EquipodeProteccionPersonal: {
        title: "LP01_EPP_EquipodeProteccionPersonal",
        process: "EPP",
        intents: 0,
        points: 0,
        errors: 0,
        responses: [],
        repetitions: 0,
    },
    LP01_LOTO_Despaletizadora: {
        title: "LP01_LOTO_Despaletizadora",
        process: "LOTO",
        intents: 0,
        points: 0,
        errors: 0,
        responses: [],
        repetitions: 0,
    },
    LP01_LOTO_Paletizadora: {
        title: "LP01_LOTO_Paletizadora",
        process: "LOTO",
        intents: 0,
        points: 0,
        errors: 0,
        responses: [],
        repetitions: 0,
    },
    LP01_SAM_PaletizadorayDespaletizadora: {
        title: "LP01_SAM_PaletizadorayDespaletizadora",
        process: "SAM",
        intents: 0,
        points: 0,
        errors: 0,
        responses: [],
        repetitions: 0,
    },
    LP03_EPP_EquipodeProteccionPersonal: {
        title: "LP03_EPP_EquipodeProteccionPersonal",
        process: "EPP",
        intents: 0,
        points: 0,
        errors: 0,
        responses: [],
        repetitions: 0,
    },
    LP03_LOTO_RinserLlenadorayCapsulador: {
        title: "LP03_LOTO_RinserLlenadorayCapsulador",
        process: "LOTO",
        intents: 0,
        points: 0,
        errors: 0,
        responses: [],
        repetitions: 0,
    },
    LP03_SAM_RinserLlenadorayCapsulador: {
        title: "LP03_SAM_RinserLlenadorayCapsulador",
        process: "SAM",
        intents: 0,
        points: 0,
        errors: 0,
        responses: [],
        repetitions: 0,
    },
    LP03_02_EPP_EquipodeProteccionPersonal: {
        title: "LP03_02_EPP_EquipodeProteccionPersonal",
        process: "EPP",
        intents: 0,
        points: 0,
        errors: 0,
        responses: [],
        repetitions: 0,
    },
    LP03_02_SAM_Paletizadora: {
        title: "LP03_02_SAM_Paletizadora",
        process: "SAM",
        intents: 0,
        points: 0,
        errors: 0,
        responses: [],
        repetitions: 0,
    },
    LP03_02_LOTO_Paletizadora: {
        title: "LP03_02_LOTO_Paletizadora",
        process: "LOTO",
        intents: 0,
        points: 0,
        errors: 0,
        responses: [],
        repetitions: 0,
    },
    LP03_02_SAM_Envolvedora: {
        title: "LP03_02_SAM_Envolvedora",
        process: "SAM",
        intents: 0,
        points: 0,
        errors: 0,
        responses: [],
        repetitions: 0,
    },
    LP03_02_LOTO_Envolvedora: {
        title: "LP03_02_LOTO_Envolvedora",
        process: "LOTO",
        intents: 0,
        points: 0,
        errors: 0,
        responses: [],
        repetitions: 0,
    },
    LP06_02_EPP_EquipodeProteccionPersonal: {
        title: "LP06_02_EPP_EquipodeProteccionPersonal",
        process: "EPP",
        intents: 0,
        points: 0,
        errors: 0,
        responses: [],
        repetitions: 0,
    },
    LP06_02_LOTO_Envolvedor: {
        title: "LP06_02_LOTO_Envolvedor",
        process: "LOTO",
        intents: 0,
        points: 0,
        errors: 0,
        responses: [],
        repetitions: 0,
    },
    LP06_02_LOTO_PaletizadoraMagazindePallets: {
        title: "LP06_02_LOTO_PaletizadoraMagazindePallets",
        process: "LOTO",
        intents: 0,
        points: 0,
        errors: 0,
        responses: [],
        repetitions: 0,
    },
    LP06_02_SAM_Envolvedor: {
        title: "LP06_02_SAM_Envolvedor",
        process: "SAM",
        intents: 0,
        points: 0,
        errors: 0,
        responses: [],
        repetitions: 0,
    },
    LP06_02_SAM_PaletizadoraMagazindePallets: {
        title: "LP06_02_SAM_PaletizadoraMagazindePallets",
        process: "SAM",
        intents: 0,
        points: 0,
        errors: 0,
        responses: [],
        repetitions: 0,
    },
    LP06_EPP_EquipodeProteccionPersonal: {
        title: "LP06_EPP_EquipodeProteccionPersonal",
        process: "EPP",
        intents: 0,
        points: 0,
        errors: 0,
        responses: [],
        repetitions: 0,
    },
    LP06_LOTO_MixerRinserLlenadorayCapsulador: {
        title: "LP06_LOTO_MixerRinserLlenadorayCapsulador",
        process: "LOTO",
        intents: 0,
        points: 0,
        errors: 0,
        responses: [],
        repetitions: 0,
    },
    LP06_SAM_MixerRinserLlenadorayCapsulador: {
        title: "LP06_SAM_MixerRinserLlenadorayCapsulador",
        process: "SAM",
        intents: 0,
        points: 0,
        errors: 0,
        responses: [],
        repetitions: 0,
    },
    LP07_EPP_EquipodeProteccionPersonal: {
        title: "LP07_EPP_EquipodeProteccionPersonal",
        process: "EPP",
        intents: 0,
        points: 0,
        errors: 0,
        responses: [],
        repetitions: 0,
    },
    LP07_LOTO_LlenadoraySopladora: {
        title: "LP07_LOTO_LlenadoraySopladora",
        process: "LOTO",
        intents: 0,
        points: 0,
        errors: 0,
        responses: [],
        repetitions: 0,
    },
    LP07_SAM_LlenadoraySopladora: {
        title: "LP07_SAM_LlenadoraySopladora",
        process: "SAM",
        intents: 0,
        points: 0,
        errors: 0,
        responses: [],
        repetitions: 0,
    },
    LP07_02_EPP_EquipodeProteccionPersonal: {
        title: "LP07_02_EPP_EquipodeProteccionPersonal",
        process: "EPP",
        intents: 0,
        points: 0,
        errors: 0,
        responses: [],
        repetitions: 0,
    },
    LP07_02_SAM_Paletizadora: {
        title: "LP07_02_SAM_Paletizadora",
        process: "SAM",
        intents: 0,
        points: 0,
        errors: 0,
        responses: [],
        repetitions: 0,
    },
    LP07_02_LOTO_Paletizadora: {
        title: "LP07_02_LOTO_Paletizadora",
        process: "LOTO",
        intents: 0,
        points: 0,
        errors: 0,
        responses: [],
        repetitions: 0,
    },
    LP07_02_SAM_Envolvedora: {
        title: "LP07_02_SAM_Envolvedora",
        process: "SAM",
        intents: 0,
        points: 0,
        errors: 0,
        responses: [],
        repetitions: 0,
    },
    LP07_02_LOTO_Envolvedora: {
        title: "LP07_02_LOTO_Envolvedora",
        process: "LOTO",
        intents: 0,
        points: 0,
        errors: 0,
        responses: [],
        repetitions: 0,
    },
} 



// eslint-disable-next-line
export const UserPerfilParesa = ({ grupo, nameUser, matricula, Fecha_y_hora }) => {
    const { arrayData } = useSelector((state) => state.table);
    const [dataAnalized, setdataAnalized] = useState(baseNamesEstructure)
    const { typeAdmin } = useSelector((state) => state.auth)
    const { proyectSelected } = useSelector((state) => state.vrlSlice);
    // const { proyects } = useSelector((state) => state.vrlSlice);
    const [pageSelected, setpageSelected] = useState(0)

    const { responses } = useSelector((state) => {
        if (typeAdmin === "VRT") {
            return state.vrtSlice
        }
        else {
            return state.vrlSlice
        }
    });
    // eslint-disable-next-line
    const [dataFilterPerUser, setFileterData] = useState([])
    const [filterResponses, setfilterResponses] = useState([])

    const formatedDate = (date) => {
        const fecha = new Date(date);
        return fecha.toLocaleString('es-ES', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
        });
    }




    const onchangePage = (next, count) => {
        setpageSelected(actual => {
            const suma = actual + next
            if (suma >= count) {
                return 0
            }
            if (suma <= -1) {
                return count - 1
            }
            else {
                return suma
            }

        })
    }


    useEffect(() => {
        console.clear();
        setdataAnalized([]);

        const conjunts = arrayData
            .filter(obj => obj.matricula === matricula)
            .map(obj => ({
                ...obj,
                Fecha_y_hora: formatedDate(obj.Fecha_y_hora),
            }));

        const objetoMasReciente = conjunts.reduce((masReciente, actual) => {
            const fechaActual = new Date(actual.Fecha_y_hora.split(', ').reverse().join(' '));
            const fechaMasReciente = new Date(masReciente.Fecha_y_hora.split(', ').reverse().join(' '));
            return fechaActual > fechaMasReciente ? actual : masReciente;
        });
        console.log(objetoMasReciente)
        let sumIntentsFormated = [];

        // 🚨 Clona baseNamesEstructure para no reutilizar referencias previas
        const datainfo = Object.fromEntries(
            Object.entries(baseNamesEstructure).map(([key, value]) => [
                key,
                {
                    ...value,
                    intents: 0,
                    points: 0,
                    errors: 0,
                    responses: [],
                },
            ])
        );

        const objects = [objetoMasReciente]

        objects.forEach(response => {
            for (const key in datainfo) {
                if (response.responsesOriginal[key]) {
                    datainfo[key].repetitions = response.responsesOriginal[key].intents
                    response.responsesOriginal[key].steps.forEach(step => {
                        datainfo[key].intents++;
                        if (step.isCompleted && step.isCorrectOrder) {
                            datainfo[key].points += 2;
                            datainfo[key].responses.push(2);
                        } else if (step.isCompleted || step.isCorrectOrder) {
                            datainfo[key].points++;
                            datainfo[key].errors++;
                            datainfo[key].responses.push(1);
                        } else {
                            datainfo[key].errors++;
                            datainfo[key].responses.push(0);
                        }
                    });
                    sumIntentsFormated.push({
                        ...datainfo[key],
                        Fecha_y_hora: response.Fecha_y_hora,
                        tiempo_intento: Math.max(Math.round(parseInt(response.responsesOriginal[key].time) / 60), 1),
                    });
                }
            }
        });

        console.log("userResults");
        console.log(datainfo);
        console.log(sumIntentsFormated);
        setdataAnalized(sumIntentsFormated);

        const sumResults = {
            timeTotal: 0,
            incorrects: 0,
            intents: 0,
        };

        sumIntentsFormated.forEach(response => {
            sumResults.timeTotal += response.tiempo_intento;
            sumResults.intents += response.intents;
            sumResults.incorrects += response.errors;
        });

        setFileterData(sumResults);
    }, [responses, proyectSelected, arrayData, Fecha_y_hora, matricula, typeAdmin, nameUser]);



    return (
        <div className='w-full h-full flex flex-col py-6 px-10'>
            <div className=' w-full h-5/12 flex items-center'>
                <div className='w-8 h-8 rounded-full flex justify-center items-center bg-[#23477D] mr-4'>
                    <p className='text-white font-semibold text-xs'> {nameUser.split(" ")[0].substring(0, 2).toUpperCase()}</p>
                </div>
                <InfoUser title={"Nombre"} text={nameUser} />
                <InfoUser title={"Matrícula"} text={matricula} />

                <InfoUser title={"Fecha y hora de registro"} text={formatedDate(Fecha_y_hora) !== "Invalid Date" ? formatedDate(Fecha_y_hora) : "Sin fecha"} />
            </div>
            <div className="pt-6">
                <p className='text-black text-base font-semibold leading-5'>Evaluaciones Paresa</p>
            </div>
            <div className='w-full h-20 flex justify-center gap-x-8 py-3'>
                <div className='h-16 pr-4 border-r border-[#686868]'>
                    <p className='pb-2'>Totales</p>
                    <div className='flex justify-start gap-x-8'>
                        <div className='flex'>
                            <img src={icons.watch} className='h-6 w-6' alt="icon time total" />
                            <div className='pl-2'>
                                <p className='text-xs text-[#686868] leading-5'>Tiempo total</p>
                                <p className='text-sm font-medium text-[#282828] leading-5'>{dataFilterPerUser.timeTotal} min</p>
                            </div>
                        </div>
                        <div className='flex'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M9.75 9.75L14.25 14.25M14.25 9.75L9.75 14.25M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z" stroke="#686868" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <div className='pl-2'>
                                <p className='text-xs text-[#686868] leading-5'>Errores Totales</p>
                                <p className='text-sm font-medium text-[#282828] leading-5'>{dataFilterPerUser.incorrects}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className=' '>
                    <p className='pb-2'>Promedios</p>
                    <div className='flex justify-start gap-x-8'>
                        <div className='flex'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M9.75 9.75L14.25 14.25M14.25 9.75L9.75 14.25M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z" stroke="#686868" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <div className='pl-2'>
                                <p className='text-xs text-[#686868] leading-5'>Errores promedio</p>
                                <p className='text-sm font-medium text-[#282828] leading-5'>{Math.round(dataFilterPerUser.incorrects / dataFilterPerUser.intents)}</p>
                            </div>
                        </div>
                        <div className='flex'>
                            <img src={icons.watch} className='h-6 w-6' alt="icon time total" />
                            <div className='pl-2'>
                                <p className='text-xs text-[#686868] leading-5'>Tiempo promedio</p>
                                <p className='text-sm font-medium text-[#282828] leading-5'>{Math.max(Math.round(dataFilterPerUser.incorrects / dataFilterPerUser.intents), 1)} min.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='pl-16 pt-6'>
                <p className='text-base'><strong>Repeticiones y desafíos realizados</strong> </p>
            </div>
            <div className="w-full flex justify-center items-center pt-4">
                {
                    dataAnalized.length >= 2 &&
                    <div
                            onClick={() => { onchangePage(-1, dataAnalized.length) }}
                        className='h-full flex justify-center items-center mr-4 cursor-pointer'>
                        <div className='w-10 h-10 rounded-full shadowBtnNext flex justify-center items-center'>
                            <img src={icons.mayorqueicon} className='h-6 transform rotate-180' alt="" />
                        </div>
                    </div>
                }
                {/*  */}
                <div className='w-[744px] h-[330px] rounded-3xl shadow-3xl pt-2 px-4 '>
                    <div className='w-full border-b border-[#9A9A9A] px-1'>
                        <p className='text-black text-base font-semibold py-1'>
                            {dataAnalized[pageSelected]?.title
                                .replace(/_/g, ' > ')}
                        </p>

                    </div>
                    <p className='text-[#9A9A9A] text-xs'>No. de ensayo: {dataAnalized[pageSelected]?.repetitions}</p>
                    <div className='flex w-full gap-6 pb-4 justify-center pt-6'>

                        <InfoIntent icon={icons.initialDate} title={'Fecha de inicio'} data={dataAnalized[pageSelected]?.Fecha_y_hora || 'Sin fecha'}></InfoIntent>
                        <InfoIntent icon={icons.watch} title={'Tiempo  realizado'} data={dataAnalized[pageSelected]?.tiempo_intento || 'Sin fecha'}></InfoIntent>
                        <InfoIntent icon={icons.start} title={'Calificación obtenida:'} data={dataAnalized[pageSelected]?.points}></InfoIntent>

                        {/* <div className='flex gap-2'>
                            <img src={icons.progress} className="w-6 h-6" alt="icono de fecha" />
                            <div>
                                <p className='text-[#686868] text-xs font-medium '>Puntaje</p>
                                <div className='w-[112px] text-[#9A9A9A] text-xs font-normal leading-5'>
                                    <p className='w-[112px] text-center leading-5 py-1'>{dataFilterPerUser[pageSelected]?.puntaje || 'Sin puntaje'}</p>
                                    <div className='w-full h-1 bg-[#d9d9d9] rounded'>
                                        <div
                                            style={{ width: dataFilterPerUser[pageSelected]?.puntaje.split('/')[0] + '%' || '0%' }}
                                            className={`h-full ${dataFilterPerUser[pageSelected]?.puntaje.split('/')[0] < 100 ? 'bg-[#F2B840]' : 'bg-[#89EB7E]'} `}></div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        {/* <InfoIntent icon={icons.progress} title={'Progreso'} data={dataFilterPerUser[pageSelected]?.Porcentaje_total || 'Sin progreso'}></InfoIntent> */}
                        {/* <InfoIntent icon={icons.pointsSheld} title={'Puntaje'} data={dataFilterPerUser[pageSelected]?.puntaje || 'Sin puntaje'}></InfoIntent> */}
                    </div>
                    <div className='w-full h-10 bg-[#23477D] rounded flex'>
                        <div className='w-2/12 flex justify-start items-center px-2'>
                            <p className='text-white font-bold text-xs'>Proceso</p>
                        </div>
                        <div className='w-7/12 flex justify-center items-center'>
                            <p className='text-white font-bold text-xs'>Desempeño </p>
                        </div>
                        <div className='w-1/12 flex justify-center items-center'>
                            <p className='text-white font-bold text-xs'>Aciertos </p>
                        </div>
                        <div className='w-2/12 flex justify-center items-center'>
                            <p className='text-white font-bold text-xs'>Puntos logrados</p>
                        </div>
                        {/* <div className='w-8/12 flex justify-center items-center'>
                            <p className='text-white font-bold text-xs'>Tiempo</p>
                        </div> */}

                    </div>
                    {/* epp */}
                    <div className='h-[200px] overflow-y-auto pt-4 '>
                        <div className='w-full flex py-2'>
                            <div className='w-2/12 flex justify-start items-center px-2'>
                                <p className='text-xs font-medium text-[#686868]'>{dataAnalized[pageSelected]?.process}</p>
                            </div>
                            <div className='w-7/12 flex justify-start flex-wrap gap-1'>
                                {
                                    dataAnalized[pageSelected]?.responses.map((obj, index) => {
                                        return <CubeIntent key={index} finded={obj} maxValue={2} title={"1"}></CubeIntent>
                                    })
                                }
                            </div>
                            <div className='w-1/12 flex justify-start items-center px-2'>
                                <p className='text-xs font-medium text-[#686868]'>
                                    {`${dataAnalized[pageSelected]?.responses.filter(x => x === 2).length}/${dataAnalized[pageSelected]?.responses.length}`}
                                </p>
                            </div>
                            <div className='w-2/12 flex justify-center items-center px-2'>
                                <p className='text-xs font-medium text-[#686868]'>
                                    {dataAnalized[pageSelected]?.points}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                {/*  */}
                {
                    dataAnalized.length >= 2 &&
                    <div
                            onClick={() => { onchangePage(1, dataAnalized.length) }}
                        className='h-full flex justify-center items-center pl-4 cursor-pointer'>
                        <div className='w-10 h-10 rounded-full shadowBtnNext flex justify-center items-center'>
                            <img src={icons.mayorqueicon} className='h-6 ' alt="" />
                        </div>
                    </div>
                }
            </div>
            <div className='w-full flex justify-center gap-x-2 pt-4'>
                {dataAnalized.length >= 2 && <PageViewer pageSelected={pageSelected} dataFilterPerUser={dataAnalized.length}></PageViewer>}

            </div>
        </div>
    )
}


const PageViewer = ({ pageSelected, dataFilterPerUser }) => {
    const rows = []
    for (let index = 0; index < dataFilterPerUser; index++) {
        rows.push(
            <div key={index} className={`w-2 h-2 
                ${pageSelected === index ? "bg-[#14A6E0] bg-opacity-100" : "bg-black bg-opacity-40"}
                 rounded-full`}></div>
        )
    }
    return rows
}

const InfoUser = ({ title, text }) => {
    return (
        <div className='w-2/6 h-full flex items-center'>
            <p className='text-[#686868]  text-xs font-medium leading-5'>{title}: </p>
            <p className='text-[#454545] text-xs font-normal pl-2 leading-5'>{text}</p>
        </div>
    )
}

const CubeIntent = ({ finded, maxValue, title }) => {
    if (finded >= 0) {
        let color = "bg-red-500";
        if (finded === 2) {
                color = "bg-[#89EB7E]"; // verde
        } else if (finded === 1) {
                color = "bg-[#d1ba00]"; // amarillo
        } else if (finded === 0) {
            color = "bg-red-500"; // rojo
        }
        return (
            <Tooltip placement="rightTop" title={
                <div className={`flex gap-2 w-auto flex-wrap text-white`}>
                    {
                        finded
                    }
                </div>
            } color="#2A3A45" overlayInnerStyle={{ color: "#2A3A45" }}>

                <div className={`w-7 h-7 cursor-pointer rounded-[4px] flex justify-center items-center text-xs text-white font-semibold ${color}`}>
                    <p className='text-white font-bold text-xs'>+{finded}</p>
                </div>
            </Tooltip>
        )
    }
    else {
        return <div className={`w-7 h-7 cursor-pointer rounded-[4px] flex justify-center items-center text-xs text-white font-semibold bg-gray-300`}>
            <p className='text-white font-bold text-xs'> </p>
        </div>
    }
}

const CubeIntentTootltip = ({ value, maxValue }) => {

    let color;
    const numericValue = parseInt(value);
    if (maxValue === 5) {
        if (numericValue === 5) {
            color = "bg-[#89EB7E]"; // verde
        } else if ([4].includes(numericValue)) {
            color = "bg-[#d1ba00]"; // amarillo
        } else if ([0, 1, 2, 3].includes(numericValue)) {
            color = "bg-red-500"; // rojo
        } else {
            color = "bg-gray-300"; // color por defecto si el valor no es 0-5
        }
    }
    else if (maxValue === 10) {
        if (numericValue === 10) {
            color = "bg-[#89EB7E]"; // verde
        } else if ([7, 8, 9].includes(numericValue)) {
            color = "bg-[#d1ba00]"; // amarillo
        } else if ([0, 1, 2, 3, 4, 5, 6].includes(numericValue)) {
            color = "bg-red-500"; // rojo
        } else {
            color = "bg-gray-300"; // color por defecto si el valor no es 0-5
        }
    }
    else if (maxValue === 6) {
        if (numericValue === 6) {
            color = "bg-[#89EB7E]"; // verde
        } else if ([4, 5].includes(numericValue)) {
            color = "bg-[#d1ba00]"; // amarillo
        } else if ([0, 1, 2, 3].includes(numericValue)) {
            color = "bg-red-500"; // rojo
        } else {
            color = "bg-gray-300"; // color por defecto si el valor no es 0-5
        }
    }

    return (
        <div className={`w-9 h-9 cursor-pointer rounded-[4px] flex justify-center items-center text-xs text-white font-semibold ${color}`}>
            {
                parseInt(value) >= 0 &&
                <p className='text-white font-bold text-xs'> {value}/{maxValue}</p>
            }
        </div>
    )
}


const InfoIntent = ({ icon, title, data }) => {
    return (
        <div className='flex gap-2'>
            <img src={icon} className="w-6 h-6" alt="icono de fecha" />
            <div>
                <p className='text-[#686868] text-xs font-medium leading-5'>{title}</p>
                <p className='w-[112px] text-[#9A9A9A] text-xs font-normal leading-5'>{data}</p>
            </div>
        </div>
    )
}


export default UserPerfilParesa
